export default "__VITE_ASSET__CczEIvx___"